import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import usbService from "../js/usb-services.js";
import commonApiService from "../../common/js/common-api-service.js";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      required: [(v) => !!v || "Field is required"],
      searchResult: [],
      searchPanel: false,
      workcenterRepair: false,
      issueFromBenchValid: false,
      searchUnit: "",
      searchUnitDisable: true,
      showBenchIssues: false,
      benchIssues: [],
      repairSuccessful: "",
      moveToWFPComments: "",
      moveToWFPDialog: false,
      repairComments: "",
      repairSuccessfulList: [
        {
          text: "Yes",
          value: "Y",
        },
        {
          text: "No",
          value: "N",
        },
      ],
      repairCostOverThresholdList: [
        {
          text: "Yes - Over Threshold",
          value: "Y",
        },
        {
          text: "No - Under Threshold",
          value: "N",
        },
      ],
      repairReason: "",
      repairReasonList: [],
      repairAction: "",
      repairActionList: [],
      failCodeList: [],
      failCode: "",
      showFailCode: false,
      stagingLocation: EncryptUtility.localStorageDecrypt("StagingLocation"),
      lpn: EncryptUtility.localStorageDecrypt("LPNNumber"),
      showRepairReason: false,
      showRepairAction: false,
      showStagingLocLPN: false,
      showComments: false,
      showSubmit: false,
      issueFromBenchStock: false,
      disableSubmitIssue: true,
      partNumberSearch: "",
      partNumberFilled: false,
      partDetails: false,
      partsList: [],
      showPartDetails: false,
      numberPart: "",
      descriptionPart: "",
      primaryPart: false,
      showExtraFields: false,
      popFailCode: "",
      popFailCodeList: [],
      popRepairAction: "",
      popRepairActionList: [],
      lpnQuantity: 1,
      showSerialNumber: false,
      selectedPartNum: "",
      serialNum: "",
      partId: 0,
      submit: false,
      partDeleteDialog: false,
      deletePartName: "",
      deletePartData: [],
      repairCost: 0,
      whyRepairNotSuccessful: "",
      showRepairCostOverThreshold: false,
      showRepairCost: false,
      showWhyRepairNotSuccessful: false,
      repairCostOverThreshold: "",
      showMoveToRepair: false,
      showPrimary: true,
      printerConfigured: false,
      showLastTransaction: false,
      lastTransaction: [],
      disableLabelsOn: false,
      labelsOn: true,
      primaryLabelSize: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
      primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
      numberRule: [(v) => /^\d*\.?\d*$/.test(v) || "Only numbers are allowed", (v) => !!v || "Field is required"],
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      LPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 characters",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
      benchIssuesHeaders: [
        { text: "Part#", align: "start", value: "Part#", class: "primary customwhite--text" },
        { text: "Unit ID", value: "Unit_ID", class: "primary customwhite--text" },
        { text: "Quantity", value: "Qty", class: "primary customwhite--text" },
        { text: "Issued", value: "Issued", class: "primary customwhite--text" },
        { text: "Tech", value: "Tech", class: "primary customwhite--text" },
        { text: "", value: "IncrementQuantity", class: "primary customwhite--text" },
        { text: "", value: "ReverseIssue", class: "primary customwhite--text" },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.labelsOn = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
      this.labelValue = this.labelsOn;
    }
    this.onChangeLabelFunction(this.labelsOn);
    if (this.labelsOn) {
      if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
        this.searchUnitDisable = false;
        this.printerConfigured = false;
      } else {
        this.searchUnitDisable = true;
        this.printerConfigured = true;
        let Alert = {
          type: "error",
          isShow: true,
          message: "Receiving/Inventory Printer is not configured, please configure printer",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    }
  },
  mounted() {},
  methods: {
    //Reset Function
    resetFunction() {
      this.searchResult = [];
      this.searchPanel = false;
      this.workcenterRepair = false;
      this.searchUnit = "";
      this.searchUnitDisable = false;
      this.showBenchIssues = false;
      this.showMoveToRepair = false;
      this.benchIssues = [];
      this.repairSuccessful = "";
      this.repairReasonList = [];
      this.repairReason = "";
      this.repairActionList = [];
      this.failCodeList = [];
      this.failCode = "";
      this.repairCost = 0;
      this.whyRepairNotSuccessful = "";
      this.repairCostOverThreshold = "";
      this.repairAction = "";
      this.showRepairReason = false;
      this.showRepairAction = false;
      this.showStagingLocLPN = false;
      this.showComments = false;
      this.showSubmit = false;
      this.issueFromBenchStock = false;
      this.disableSubmitIssue = true;
      this.showFailCode = false;
      this.showWhyRepairNotSuccessful = false;
      this.showRepairCostOverThreshold = false;
      this.showRepairCost = false;
      this.moveToWFPComments = "";
      this.repairComments = "";
      this.moveToWFPDialog = false;
      this.$refs.workcenterRepairForm.resetValidation();
    },
    async searchUnitIdentifier() {
      if (this.$refs.workcenterRepairForm.validate()) {
        let obj = {
          unit: this.searchUnit,
          user_id: parseInt(this.userId),
          main_key: 0,
        };
        this.searchResult = await usbService.repairGetHeaderByUnit("post", obj);
        if (this.searchResult.message !== "NA") {
          this.searchPanel = true;
          this.searchUnitDisable = true;
          this.showLastTransaction = false;
          this.lastTransaction = [];
          if (this.searchResult?.Result[0]?.loc == "P01") {
            this.showMoveToRepair = true;
          } else {
            this.showBenchIssues = true;
            this.showMoveToRepair = false;
            let benchData = await usbService.getRepairBenchList("get", this.userId, this.searchResult?.Result[0]?.main_id);
            if (benchData.message !== "NA") {
              this.benchIssues = benchData;
            } else {
              this.benchIssues = [];
            }
          }
        }
      }
    },
    async moveToRepair() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let moveToRepairObj = {
        unit: this.searchUnit,
        user_id: parseInt(this.userId),
        move_main_key: this.searchResult?.Result[0]?.main_id,
        sysloc: this.searchResult?.Result[0]?.loc,
        comments: this.moveToWFPComments,
      };
      this.axios
        .post("/wc/repair_move_unit", moveToRepairObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.searchUnitIdentifier();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get LPN Number
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.lpn = lpnData[0]?.lpn;
        EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
      }
    },
    //LPN Number Format
    lpnNumFormat(event, num) {
      this.lpn = Utility.formatLPNNumber(event, num);
      EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
    },
    //Input at Staging Location
    inputStagingLocation() {
      this.stagingLocation = this.stagingLocation?.toUpperCase();
      EncryptUtility.localStorageEncrypt("StagingLocation", this.stagingLocation);
    },
    //Close Dialog
    closeDialog() {
      this.showPartDetails = false;
      this.partNumberSearch = "";
      this.partDetails = false;
      this.partsList = [];
      this.numberPart = "";
      this.descriptionPart = "";
      this.issueFromBenchStock = false;
      this.disableSubmitIssue = true;
      this.primaryPart = false;
      this.showExtraFields = false;
      this.popFailCode = "";
      this.popFailCodeList = [];
      this.popRepairAction = "";
      this.popRepairActionList = [];
      this.lpnQuantity = 1;
      this.showSerialNumber = false;
      this.serialNum = "";
      this.partId = 0;
    },
    //Part Number Search
    async searchPartNumber() {
      if (this.selectedPartNum && this.partNumberSearch !== this.selectedPartNum) {
        this.clearSelection();
      }
      if (!this.partNumberSearch || this.partNumberSearch.trim() === "") {
        this.partsList = [];
        this.partDetails = false;
        return;
      }
      this.partDetails = true;
      let partSearchObj = {
        user_id: parseInt(this.userId),
        searchstr: this.partNumberSearch,
        main_key: this.searchResult?.Result[0]?.main_id,
      };

      let partData = await usbService.repairGetBenchIssueParts("post", partSearchObj);

      if (Array.isArray(partData) && partData.length > 0) {
        this.partsList = partData;
        this.showSerialNumber = false;
        this.serialNum = "";
      } else {
        this.partsList = [];
        this.partDetails = false;
      }
    },

    clearSelection() {
      this.partId = 0;
      this.selectedPartNum = "";
      this.partNumberFilled = false;
      this.showPartDetails = false;
      this.numberPart = "";
      this.descriptionPart = "";
      this.disableSubmitIssue = true;
      this.showExtraFields = false;
      this.primaryPart = false;
      this.popFailCode = "";
      this.popRepairAction = "";
      this.lpnQuantity = 1;
      this.showSerialNumber = false;
      this.serialNum = "";
    },

    //Clear Part Number Search
    clearPartNumber() {
      this.partNumberSearch = "";
      this.partDetails = false;
      this.partsList = [];
      this.numberPart = "";
      this.descriptionPart = "";
      this.disableSubmitIssue = true;
      this.showExtraFields = false;
      this.primaryPart = false;
      this.popFailCode = "";
      this.popRepairAction = "";
      this.lpnQuantity = 1;
      this.showSerialNumber = false;
      this.serialNum = "";
    },
    //Get Dropdown data
    async getDropdownData() {
      let failData = await usbService.getRepairFailCodeList("get", this.userId, this.searchResult?.Result[0]?.main_id);
      if (failData.message !== "NA") {
        this.popFailCodeList = failData;
      } else {
        this.popFailCodeList = [];
      }
      let actionData = await usbService.getRepairActionList("get", this.userId, this.searchResult?.Result[0]?.main_id);
      if (actionData.message !== "NA") {
        this.popRepairActionList = actionData;
      } else {
        this.popRepairActionList = [];
      }
    },
    //Show Part Description
    async showPartDesc(item) {
      this.partsList = [];
      this.showPartDetails = true;
      this.partNumberFilled = false;
      this.numberPart = item.part_num;
      this.selectedPartNum = item.part_num;
      this.descriptionPart = item.part_desc;
      this.partId = item.part_id;
      this.partNumberSearch = item.part_num;
      this.showSerialNumber = item.serialno;
      this.serialNum = "";
      this.showExtraFields = true;
    },
    //Move to WFP
    moveToWFP() {
      if (this.$refs.moveToWFPCommentsForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let moveToWFPObj = {
          unit: this.searchUnit,
          user_id: parseInt(this.userId),
          move_main_key: this.searchResult?.Result[0]?.main_id,
          sysloc: this.searchResult?.Result[0]?.loc,
          comments: this.moveToWFPComments,
        };
        this.axios
          .post("/wc/repair_move_unit", moveToWFPObj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.resetFunction();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Add New Issue to Bench
    addIssueToBench() {
      if (this.$refs.issueFromBenchForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let addBenchIssueObj = {
          user_id: parseInt(this.userId),
          main_key: this.searchResult?.Result[0]?.main_id,
          part_num: this.numberPart,
          failc_key: this.popFailCode,
          repair_key: this.popRepairAction,
          qty: this.lpnQuantity,
          serialno: this.serialNum,
          primary_part: this.primaryPart,
        };
        this.axios
          .post("/wc/repair_bench_issue", addBenchIssueObj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              this.benchIssues = data;
              this.closeDialog();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Repair Successful Change
    async repairSuccessfulChange() {
      let obj = {
        User_id: parseInt(this.userId),
        results: this.repairSuccessful,
      };
      let data = await usbService.getRepairReasons("post", obj, false);
      if (data.message !== "NA") {
        this.repairReasonList = data;
        this.showRepairReason = true;
        this.repairReason = "";
        this.showRepairAction = false;
        this.repairAction = "";
        this.showFailCode = false;
        this.failCode = "";
        this.showWhyRepairNotSuccessful = false;
        this.whyRepairNotSuccessful = "";
        this.showRepairCostOverThreshold = false;
        this.repairCostOverThreshold = "";
        this.showRepairCost = false;
        this.repairCost = 0;
        this.showStagingLocLPN = false;
        this.showComments = false;
        this.showSubmit = false;
        this.repairComments = "";
      }
    },
    //Repair Reason Change
    async repairReasonChange() {
      let data = await usbService.getRepairActionList("get", this.userId, this.searchResult?.Result[0]?.main_id);
      if (data.message !== "NA") {
        this.repairActionList = data;
        this.showRepairAction = true;
        this.repairAction = "";
        this.showFailCode = false;
        this.failCode = "";
        this.showWhyRepairNotSuccessful = false;
        this.whyRepairNotSuccessful = "";
        this.showRepairCostOverThreshold = false;
        this.repairCostOverThreshold = "";
        this.showRepairCost = false;
        this.repairCost = 0;
        this.showStagingLocLPN = false;
        this.showComments = false;
        this.showSubmit = false;
        this.repairComments = "";
      }
    },
    //Repair Action Change
    async repairActionChange() {
      this.failCode = "";
      this.showWhyRepairNotSuccessful = false;
      this.whyRepairNotSuccessful = "";
      this.showRepairCostOverThreshold = false;
      this.repairCostOverThreshold = "";
      this.showRepairCost = false;
      this.repairCost = 0;
      this.showStagingLocLPN = false;
      this.showComments = false;
      this.showSubmit = false;
      this.repairComments = "";
      if (this.repairSuccessful == "Y") {
        this.showComments = true;
        this.showStagingLocLPN = true;
        this.showSubmit = true;
      } else if (this.repairSuccessful == "N") {
        let data = await usbService.getRepairFailCodeList("get", this.userId, this.searchResult?.Result[0]?.main_id);
        if (data.message !== "NA") {
          this.failCodeList = data;
          this.showFailCode = true;
        }
      }
    },
    //Fail Code Change
    failCodeChange() {
      this.showWhyRepairNotSuccessful = true;
      this.showRepairCostOverThreshold = true;
      this.whyRepairNotSuccessful = "";
      this.repairCostOverThreshold = "";
      this.showRepairCost = false;
      this.repairCost = 0;
      this.showStagingLocLPN = false;
      this.showComments = true;
      this.showSubmit = false;
      this.repairComments = "";
    },
    //Repair Cost Over Threshold Change
    repairCostOverThresholdChange() {
      if (this.repairCostOverThreshold == "Y") {
        this.repairCost = 0;
        this.showRepairCost = true;
        this.showStagingLocLPN = true;
        this.showSubmit = true;
      } else if (this.repairCostOverThreshold == "N") {
        this.showRepairCost = false;
        this.repairCost = 0;
        this.showStagingLocLPN = true;
        this.showSubmit = true;
      }
    },
    //Move to WFP
    submitRepair() {
      if (this.$refs.submitForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let submitObj = {
          user_id: parseInt(this.userId),
          main_key: parseInt(this.searchResult?.Result[0]?.main_id),
          passfail: this.repairSuccessful,
          repair_reason: this.repairReason,
          failc_key: this.failCode == "" ? 0 : this.failCode,
          repair_key: this.repairAction,
          unsuccessful_repair_reason: this.whyRepairNotSuccessful,
          repair_cost_over_threshold: this.repairCostOverThreshold == "Y" ? true : false,
          repair_cost: parseInt(this.repairCost),
          lbl_size: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
          printer_type: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
          lpn: this.lpn,
          bin: this.stagingLocation,
          comments: this.repairComments,
        };
        this.axios
          .post("/wc/repair_submit", submitObj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
              this.resetFunction();
              this.showLastTransaction = true;
              if (data.message !== null && data.message != undefined && data.message != "") {
                this.lastTransaction = data.message;
              }
              if (data.label !== null && data.label != undefined && data.label != "") {
                this.labelsOn ? PrinterDetails.printLabelData(data.label, EncryptUtility.localStorageDecrypt("primaryName")) : "";
              }
              this.$refs.submitForm.resetValidation();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            this.showLastTransaction = false;
            this.lastTransaction = [];
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Increment Quantity
    async incrementQuantity(item) {
      let obj = {
        user_id: parseInt(this.userId),
        issue_id: parseInt(item.issue_id),
      };
      let data = await usbService.repairBenchIssueIncrement("post", obj, false);
      if (data.message !== "NA") {
        this.benchIssues = data;
      } else {
        this.benchIssues = [];
      }
    },
    //Reverse Issue
    async reverseIssue(item) {
      this.deletePartData = [];
      this.deletePartData = item;
      this.partDeleteDialog = true;
      this.deletePartName = item["Part#"];
    },
    async deletePart() {
      let obj = {
        user_id: parseInt(this.userId),
        issue_id: parseInt(this.deletePartData.issue_id),
      };
      let data = await usbService.repairBenchIssueReverse("post", obj, false);
      if (data.message !== "NA") {
        this.benchIssues = data;
      } else {
        this.benchIssues = [];
      }
      this.partDeleteDialog = false;
      this.deletePartData = [];
      this.deletePartName = "";
    },
    //Labels On/Off
    labelsOnChange() {
      if (this.labelsOn) {
        this.primaryName = EncryptUtility.localStorageDecrypt("primaryName");
        this.primaryLabelSize = EncryptUtility.localStorageDecrypt("primaryLabelSize");
        this.primaryPrinterType = EncryptUtility.localStorageDecrypt("primaryPrinterType");
      } else {
        this.primaryName = "";
        this.primaryLabelSize = "";
        this.primaryPrinterType = "";
      }
    },
    //To check if its a number of not
    isNumber(event) {
      let value = Utility.isNumber(event);
      return value;
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.searchUnitDisable = false;
        this.printerConfigured = false;
      } else {
        this.searchUnitDisable = true;
        this.printerConfigured = true;
      }
    },
    //Label change function
    onChangeLabelFunction(val) {
      this.labelValue = val;
      this.labelsOn = val;
      if (!this.labelsOn) {
        this.searchUnitDisable = false;
      }
      EncryptUtility.localStorageEncrypt("LabelSwitchValue", JSON.stringify(this.labelsOn));
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
